"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteBulletin = exports.downloadMyBulletin = exports.meetingBuySmsConfirmation = exports.bulletingHistoryComment = exports.projectDecisionManualComment = exports.manualComment = exports.readHistory = exports.deleteComment = exports.deleteThreadComment = exports.editThreadComment = exports.editComment = exports.replyComment = exports.addComment = exports.setRatingProjectDecision = exports.sendMeetingBulletinsToMail = exports.meetingBulletinsVotingNotSave = exports.meetingBulletinsRegistration = exports.registryActualization = exports.republishProtocol = exports.cancelPublicationProtocol = exports.deleteSignedProtocol = exports.confirmPublishProtocol = exports.initPublishProtocol = exports.uploadSignedProtocol = exports.addSignersToProtocol = exports.startMeetingProtocolPublish = exports.sendMeetingNotification = exports.copyQuestionsFormTemplate = void 0;
var copyQuestionsFormTemplate_1 = require("./copyQuestionsFormTemplate");
Object.defineProperty(exports, "copyQuestionsFormTemplate", {
  enumerable: true,
  get: function () {
    return __importDefault(copyQuestionsFormTemplate_1).default;
  }
});
var sendMeetingNotification_1 = require("./sendMeetingNotification");
Object.defineProperty(exports, "sendMeetingNotification", {
  enumerable: true,
  get: function () {
    return __importDefault(sendMeetingNotification_1).default;
  }
});
var startMeetingProtocolPublish_1 = require("./startMeetingProtocolPublish");
Object.defineProperty(exports, "startMeetingProtocolPublish", {
  enumerable: true,
  get: function () {
    return __importDefault(startMeetingProtocolPublish_1).default;
  }
});
var addSignersToProtocol_1 = require("./addSignersToProtocol");
Object.defineProperty(exports, "addSignersToProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(addSignersToProtocol_1).default;
  }
});
var uploadSignedProtocol_1 = require("./uploadSignedProtocol");
Object.defineProperty(exports, "uploadSignedProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(uploadSignedProtocol_1).default;
  }
});
var initPublishProtocol_1 = require("./initPublishProtocol");
Object.defineProperty(exports, "initPublishProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(initPublishProtocol_1).default;
  }
});
var confirmPublishProtocol_1 = require("./confirmPublishProtocol");
Object.defineProperty(exports, "confirmPublishProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(confirmPublishProtocol_1).default;
  }
});
var deleteSignedProtocol_1 = require("./deleteSignedProtocol");
Object.defineProperty(exports, "deleteSignedProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(deleteSignedProtocol_1).default;
  }
});
var cancelPublicationProtocol_1 = require("./cancelPublicationProtocol");
Object.defineProperty(exports, "cancelPublicationProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(cancelPublicationProtocol_1).default;
  }
});
var republishProtocol_1 = require("./republishProtocol");
Object.defineProperty(exports, "republishProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(republishProtocol_1).default;
  }
});
var registryActualization_1 = require("./registryActualization");
Object.defineProperty(exports, "registryActualization", {
  enumerable: true,
  get: function () {
    return __importDefault(registryActualization_1).default;
  }
});
var meetingBulletinsRegistration_1 = require("./meetingBulletinsRegistration");
Object.defineProperty(exports, "meetingBulletinsRegistration", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsRegistration_1).default;
  }
});
var meetingBulletinsVotingNotSave_1 = require("./meetingBulletinsVotingNotSave");
Object.defineProperty(exports, "meetingBulletinsVotingNotSave", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsVotingNotSave_1).default;
  }
});
var sendMeetingBulletinsToMail_1 = require("./sendMeetingBulletinsToMail");
Object.defineProperty(exports, "sendMeetingBulletinsToMail", {
  enumerable: true,
  get: function () {
    return __importDefault(sendMeetingBulletinsToMail_1).default;
  }
});
var ratingQuestionProjectDecision_1 = require("./ratingQuestionProjectDecision");
Object.defineProperty(exports, "setRatingProjectDecision", {
  enumerable: true,
  get: function () {
    return __importDefault(ratingQuestionProjectDecision_1).default;
  }
});
var addComment_1 = require("./addComment");
Object.defineProperty(exports, "addComment", {
  enumerable: true,
  get: function () {
    return __importDefault(addComment_1).default;
  }
});
var replyComment_1 = require("./replyComment");
Object.defineProperty(exports, "replyComment", {
  enumerable: true,
  get: function () {
    return __importDefault(replyComment_1).default;
  }
});
var editComment_1 = require("./editComment");
Object.defineProperty(exports, "editComment", {
  enumerable: true,
  get: function () {
    return __importDefault(editComment_1).default;
  }
});
var editThreadComment_1 = require("./editThreadComment");
Object.defineProperty(exports, "editThreadComment", {
  enumerable: true,
  get: function () {
    return __importDefault(editThreadComment_1).default;
  }
});
var deleteThreadComment_1 = require("./deleteThreadComment");
Object.defineProperty(exports, "deleteThreadComment", {
  enumerable: true,
  get: function () {
    return __importDefault(deleteThreadComment_1).default;
  }
});
var deleteComment_1 = require("./deleteComment");
Object.defineProperty(exports, "deleteComment", {
  enumerable: true,
  get: function () {
    return __importDefault(deleteComment_1).default;
  }
});
var readHistory_1 = require("./readHistory");
Object.defineProperty(exports, "readHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(readHistory_1).default;
  }
});
var manualComment_1 = require("./manualComment");
Object.defineProperty(exports, "manualComment", {
  enumerable: true,
  get: function () {
    return __importDefault(manualComment_1).default;
  }
});
var projectDecisionManualComment_1 = require("./projectDecisionManualComment");
Object.defineProperty(exports, "projectDecisionManualComment", {
  enumerable: true,
  get: function () {
    return __importDefault(projectDecisionManualComment_1).default;
  }
});
var bulletinHistoryComment_1 = require("./bulletinHistoryComment");
Object.defineProperty(exports, "bulletingHistoryComment", {
  enumerable: true,
  get: function () {
    return __importDefault(bulletinHistoryComment_1).default;
  }
});
var buySmsConfirmation_1 = require("./buySmsConfirmation");
Object.defineProperty(exports, "meetingBuySmsConfirmation", {
  enumerable: true,
  get: function () {
    return __importDefault(buySmsConfirmation_1).default;
  }
});
var downloadMyBulletin_1 = require("./downloadMyBulletin");
Object.defineProperty(exports, "downloadMyBulletin", {
  enumerable: true,
  get: function () {
    return __importDefault(downloadMyBulletin_1).default;
  }
});
var deleteBulletin_1 = require("./deleteBulletin");
Object.defineProperty(exports, "deleteBulletin", {
  enumerable: true,
  get: function () {
    return __importDefault(deleteBulletin_1).default;
  }
});